import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { styled } from 'styled-components';
import { Site, CountryCode, Entity } from '@debbie/common/dist/index.js';
import { getCollectorOnCase } from '@debbie/common/dist/cases/index.js';
import { c, h } from '@debbie/cortex/dist/index.js';
import * as casesLib from '@debbie/cortex/dist/api/cases.js';
import { selectCaseUpdates } from '@debbie/cortex/dist/case/selectors.js';
import { selectCaseById } from '@debbie/cortex/dist/cases/selectors.js';
import { selectCustomerById } from '@debbie/cortex/dist/customers/selectors.js';
import { selectExclusiveContent } from '@debbie/cortex/dist/exclusiveContent/selectors.js';
import { selectMe } from '@debbie/cortex/dist/me/selectors.js';
import { selectTenant } from '@debbie/cortex/dist/tenant/selectors.js';
import { PlaceholderLoader, CopyToClipboard, EditReferenceId, } from '..//index.js';
import { APIBASE } from '../../config.js';
import CustomerPreview from '../Customers/CustomerPreview.js';
import { Row, Col } from '../Grid/index.js';
import RKIReporting from '../RKIReporting/index.js';
import CasePrediction from '../wincent/CasePrediction.js';
import CasePaymentPlan from './CasePaymentPlan.js';
import CaseSatisfactions from './CaseSatisfactions.js';
import FromCase from './FromCase.js';
import FsNumbers from './FsNumbers.js';
import Header from './Header.js';
import ImportantUpdates from './ImportantUpdates.js';
import { useCaseVouchersByCase } from '@debbie/cortex/dist/case-vouchers/index.js';
import { useInteractionsByReference } from '@debbie/cortex/dist/interactions/index.js';
import { usePaymentPlansByCaseId } from '@debbie/cortex/dist/paymentPlans/index.js';
import { useDocumentsByReference } from '@debbie/cortex/dist/documents/index.js';
import { useCreditor } from '@debbie/cortex/dist/creditors/index.js';
import { useCollector } from '@debbie/cortex/dist/collectors/index.js';
import { TenantType } from '@debbie/common/dist/tenants/index.js';
const CaseInfo = (props) => {
    const lang = useSelector((s) => s.lang);
    const site = useSelector((s) => s.site);
    const tenant = useSelector(selectTenant);
    const me = useSelector(selectMe);
    const exclusiveContent = useSelector(selectExclusiveContent);
    const isCaseNotLoaded = useSelector((s) => h.isNotLoaded(s.cases[props.caseId]));
    const singleCase = useSelector((s) => selectCaseById(s, props.caseId));
    const customer = useSelector((s) => singleCase && selectCustomerById(s, singleCase.customerId));
    const caseVouchers_ = useCaseVouchersByCase(singleCase?.caseId);
    const caseVouchers = h.hasData(caseVouchers_) ? caseVouchers_.data : null;
    const paymentPlansLoadable = usePaymentPlansByCaseId(singleCase?.caseId);
    const paymentPlans = h.hasData(paymentPlansLoadable)
        ? paymentPlansLoadable.data
        : null;
    const creditorLoadable = useCreditor(singleCase?.creditorId);
    const creditor = h.hasData(creditorLoadable) ? creditorLoadable.data : null;
    const updates = useSelector((s) => singleCase && selectCaseUpdates(s, singleCase.caseId));
    const interactionsLoadable = useInteractionsByReference(Entity.Case, singleCase?.caseId, true);
    const interactions = h.hasData(interactionsLoadable)
        ? interactionsLoadable.data
        : null;
    const documentsLoadable = useDocumentsByReference(singleCase?.caseId);
    const documents = h.hasData(documentsLoadable) ? documentsLoadable.data : null;
    const collectorLoadable = useCollector((singleCase &&
        creditor &&
        getCollectorOnCase(singleCase.type, singleCase.collectorId, creditor.identityCollectorId, creditor.defaultCollectorId)) ||
        undefined);
    const collector = h.hasData(collectorLoadable) ? collectorLoadable.data : null;
    useEffect(() => {
        loadCase();
    }, [props.caseId]);
    const loadCase = () => {
        if (isCaseNotLoaded) {
            c.cases.getById(props.caseId, true);
        }
    };
    const updateMigratedId = async (id) => {
        singleCase &&
            (await casesLib.patch(singleCase.caseId, {
                migratedId: id,
            }));
        await c.cases.getById(props.caseId);
    };
    return (React.createElement("div", null,
        React.createElement(CaseInfoStyled, null, !singleCase ? (React.createElement("div", null,
            React.createElement(Col, { width: "8" },
                React.createElement(PlaceholderLoader, null),
                React.createElement("br", null),
                React.createElement(PlaceholderLoader, { width: "50%" }),
                React.createElement("br", null),
                React.createElement(PlaceholderLoader, { width: "65%" })),
            React.createElement(Col, { width: "4" },
                React.createElement(PlaceholderLoader, null)))) : (React.createElement(React.Fragment, null,
            React.createElement(Header, { caseId: props.caseId }),
            React.createElement(Col, { width: "8" },
                React.createElement(FsNumbers, { caseId: singleCase.caseId }),
                singleCase && singleCase.migratedId ? (React.createElement("p", { style: { fontSize: '0.8em' } },
                    React.createElement("small", null, "Migreret journalnummer"),
                    React.createElement("div", { style: {
                            fontFamily: "'Courier New', Courier, monospace !important",
                            fontWeight: 'bold',
                        } },
                        React.createElement(CopyToClipboard, { text: singleCase.migratedId }, singleCase.migratedId)),
                    React.createElement("br", null))) : ((singleCase.tenantId ===
                    '92b91d97-ebda-4fd3-8d48-71247af5ec8a' || //Oxilio tenantId
                    (me && exclusiveContent?.includes(me.id))) &&
                    site === Site.Caseworker && (React.createElement("span", { "data-tooltip-content": 'Tilføj migreret journalnummer', "data-tooltip-id": "tooltip-default" },
                    React.createElement(EditReferenceId, { value: singleCase.migratedId, onUpdate: updateMigratedId, placeholder: 'Migreret journalnummer', style: { marginTop: '0.5em' } })))),
                singleCase?.customerId && (React.createElement("div", { style: { marginTop: '20px' } },
                    React.createElement(CustomerPreview, { customerId: singleCase.customerId, onClickOnUser: (user) => c.redirect.redirect(`/creditors/${singleCase.creditorId}/customers/${singleCase.customerId}/users/${user.userId}?backToCaseId=${singleCase.id}&backToCasePath=${encodeURIComponent(window.location.pathname)}`), caseId: singleCase.caseId }))),
                React.createElement(CaseSatisfactions, { caseId: props.caseId }),
                React.createElement(FromCase, { caseId: props.caseId }),
                caseVouchers &&
                    singleCase &&
                    creditor &&
                    customer &&
                    documents &&
                    interactions &&
                    updates &&
                    paymentPlans && (React.createElement("div", { style: { marginTop: '16px' } },
                    React.createElement(CasePrediction, { caseVouchers: caseVouchers, case: singleCase, customer: customer, documents: documents, interactions: interactions, updates: updates, paymentPlans: paymentPlans })))),
            React.createElement(Col, { width: "4" },
                site === Site.Caseworker &&
                    tenant?.type === TenantType.Agency && (React.createElement("div", null,
                    React.createElement("div", { className: "case-info-title" }, lang.creditors.creditor),
                    // @ts-ignore
                    React.createElement(Link, { style: {
                            color: 'initial',
                            textDecoration: 'none',
                        }, to: `/creditors/${singleCase.creditorId}` },
                        React.createElement("div", { className: "case-info-content" },
                            creditor && creditor.name,
                            ' ',
                            creditor && creditor.id && (React.createElement(React.Fragment, null,
                                React.createElement("br", null),
                                React.createElement("small", { onClick: (e) => {
                                        e.preventDefault();
                                    } },
                                    React.createElement(CopyToClipboard, { text: creditor.id }, creditor && creditor.id)))))))),
                React.createElement("div", null,
                    React.createElement("div", { className: "case-info-title" }, lang.collectors.collector),
                    React.createElement("div", { className: "case-info-content" }, collector &&
                        (collector.logo ? (React.createElement(Collector, null,
                            React.createElement("img", { alt: collector.logo.fileName || undefined, src: `${APIBASE}/files/${collector.logo.fileId}/${collector.logo.fileName}` }))) : (React.createElement("span", null, collector.name))))),
                React.createElement(ImportantUpdates, { caseId: singleCase.caseId }),
                React.createElement("div", null,
                    React.createElement(CasePaymentPlan, { caseId: singleCase.caseId }),
                    singleCase &&
                        customer &&
                        caseVouchers &&
                        tenant?.aksSettings?.username &&
                        tenant.countryCode === CountryCode.DK && (React.createElement(RKIReporting, { case: singleCase, customer: customer, caseVouchers: caseVouchers })))))))));
};
export default CaseInfo;
const Collector = styled.div `
  img {
    max-height: 100%;
    max-width: 70%;
    display: block;
  }
`;
const CaseInfoStyled = styled(Row) `
  h3 {
    margin: 0;
    small {
      font-size: 0.7em;
      font-weight: normal;
    }
    & > span.border-left {
      border-left: 1px solid lightgrey;
      font-size: 0.55em;
      font-weight: normal;
      margin-left: 14px;
      padding-left: 10px;
      svg {
        margin: 5px 0 -1px 0;
      }
    }
  }
  & > div {
  }
  .case-info-title {
    color: lightgrey;
    font-size: 0.9em;
    font-weight: 900;
    margin-top: 1.3em;
    word-wrap: break-word;
  }
  .case-info-content {
    font-size: 1em;
    margin: 0.7em 0 1em 0;
    word-wrap: break-word;
  }
`;
//# sourceMappingURL=CaseInfo.js.map